<template>
  <div>
    <!-- Image Library Modal Starts -->
    <div v-if="show" id="gmbModal" class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head headnewcl">
          <span class="cross-btn" @click="closeModal"><img alt="cross" class="valign-bottom"
                                                           src="/static/img/cross.svg"/></span>
        </header>

        <section class="modal-card-body">
          <!-- Tabs Section Starts-->
          <h4 v-if="title.length > 0" class="title">{{ title }}</h4>

          <div v-if="currentPage==='locationSetup'">
            <p><img
              src="/static/img/review-invites/google-logo-png-open-2000.png"
              srcset="/static/img/review-invites/google-logo-png-open-2000@2x.png 2x,
                      /static/img/review-invites/google-logo-png-open-2000@3x.png 3x"
            /> {{ selectedAccount.accountName }} </p>

            <div class="form-group">
              <label>Your Google Account</label>
              <select v-model="selectedAccount" :disabled="isLoading" class="input" @change="getLocationsByAccount()">
                <option disabled="disabled" value="">Select an Account</option>
                <option v-for="account in accounts" :value="account">{{ account.accountName }}</option>
              </select>
            </div>

            <div class="form-group">
              <label>Location</label>
              <p style="margin: 15px 0;">You can only add 1 location to your Google Business </p>
              <ul class="location-checkbox">
                <li v-if="isLoading === false && selectedAccount && locations.length == 0" style="color: red">No
                  location found with this account.
                </li>
                <li v-for="location in locations">
                  <label class="radio"><input v-model="selectedLocation" :value="location" name="location"
                                              type="radio"/>{{ location.locationName }}
                    ({{ location.address ? location.address.addressLines[0] : '' }})</label>
                </li>
              </ul>
            </div>
          </div>


          <div v-if="currentPage==='facebookPageSelect'">
            <p><img class="fb_logo" src="/static/img/reviews/facebook_channel.png"
                    srcset="/static/img/reviews/facebook_channel@2x.png 1.5x, /static/img/reviews/facebook_channel@2x.png 2x, /static/img/reviews/facebook_channel@3x.png 3x"/>
            </p>

            <div class="form-group">
              <label>Select Facebook Page</label>
              <p style="margin: 15px 0;">You can only add 1 Facebook Page to your Hellopeter account </p>
              <ul class="location-checkbox">
                <li v-for="page in facebookPages">
                  <label class="radio">
                    <input
                      v-model="selectedLocation"
                      :value="page.pageId"
                      name="location"
                      type="radio"
                    />
                    {{ page.pageName }}
                  </label>
                </li>
              </ul>
            </div>
          </div>

          <div v-if="currentPage==='locationUpdate'">
            <p><img src="/static/img/review-invites/google-logo-png-open-2000.png"/> {{ selectedAccount.accountName }}
            </p>

            <div class="form-group">
              <label>Your Google Account</label>
              <input :value="selectedAccount.accountName" class="input" disabled="disabled" type="text"/>
            </div>

            <div class="form-group">
              <label>Location</label>
              <p style="margin: 15px 0;">You can only add 1 location to your Google Business </p>
              <ul class="location-checkbox">
                <li v-if="isLoading === false && selectedAccount.accountName && locations.length == 0"
                    style="color: red">No location found with this account.
                </li>
                <li
                  v-if="isLoading === false && (selectedLocation === '' || selectedLocation === undefined)"
                  style="color: red; margin-bottom: 10px;">
                  The location you selected in initial setup, you no longer have access to it,
                  please select a different location or Remove Account.
                </li>
                <li v-for="location in locations">
                  <label class="radio">
                    <input
                      v-model="selectedLocation"
                      :value="location"
                      name="location"
                      type="radio"
                    />
                    {{ location.locationName }} ({{ location.address.addressLines[0] }})
                  </label>
                </li>
              </ul>
            </div>
          </div>

          <div v-if="selectedLocation !== '' && isSelectedLocationVerified === false"
               class="location-not-verified columns">
            <div class="column is-1 left">!</div>
            <div class="column is-11 right">
              The selected location is not verified. Please select a verified location or
              click <a href="https://support.google.com/business/answer/7107242?hl=en" target="_blank">here</a>
              to find out how to verify your location.
            </div>
          </div>

          <p>{{ content }}</p>
          <!-- Tabs Section Ends-->
        </section>

        <footer class="modal-card-foot delete-review-footer">
          <div>
            <ul
              v-if="(currentPage == 'locationSetup' || currentPage == 'locationUpdate') && (showPrevButton || gmb.pageToken.next)"
              class="pagination-list is-hidden-mobile">
              <li v-if="showPrevButton" @click="getLocationsByAccount('prev')"><a
                aria-label="Previous"
                class="pagination-link is-size-7-touch is-size-7-desktop has-text-weight-bold is-hidden-mobile"><span>«&nbsp;Previous</span></a>
              </li>
              <li v-if="gmb.pageToken.next" @click="getLocationsByAccount(gmb.pageToken.next)"><a
                aria-label="Next"
                class="pagination-link is-size-7-touch is-size-7-desktop has-text-weight-bold is-hidden-mobile"><span>Next&nbsp;»</span></a>
              </li>
            </ul>
          </div>

          <a v-if="currentPage == 'askForAuth'" :href="authURL" class="button is-button-blue dark-blue-btn"
             data-track="Google Reviews - Setup - GO TO GOOGLE MY BUSINESS">{{ buttonText }}</a>
          <a
            v-if="currentPage == 'locationSetup' || currentPage == 'locationUpdate'"
            :disabled="(selectedAccount === '' || isSelectedLocationVerified === false)"
            class="button is-button-blue dark-blue-btn"
            data-track="Google Reviews - Setup - Add or Update location"
            style="max-width: 130px;"
            @click="saveAccountLocation()"
          >{{ buttonText }}</a>
          <a
            v-if="currentPage == 'facebookPageSelect'"
            :class="['button is-button-blue dark-blue-btn', { 'is-loading': isLoading}]"
            :disabled="selectedLocation === ''"
            data-track="Facebook Select Page"
            style="max-width: 130px;"
            @click="saveFacebookSelection()"
          >{{ buttonText }}</a>
        </footer>
      </div>
    </div>
    <!-- Image Library Modal Ends -->
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,valid-jsdoc, no-useless-escape */
import misc from '../mixins/misc.js'
import axios from 'axios'
import { mapMutations } from 'vuex'
import { SET_GMB_DATA } from '@/store/mutation.types'

export default {
  name: 'GMBModal',
  mixins: [misc],
  data () {
    return {
      isLoading: false,
      currentPage: '',
      title: '',
      content: '',
      buttonText: '',
      authURL: '',
      businessSlug: localStorage.getItem('org_slug'),
      accounts: [],
      locations: [],
      selectedAccount: '',
      selectedLocation: '',
      selectedLocationName: '',
      selectedPageToken: '',
      formData: {
        account: '',
        accountName: '',
        location: '',
        locationData: {},
        distribution: 0
      },
      gmb: {
        pageToken: {
          next: '',
          currentApiToken: '',
          logs: {}
        }
      }
    }
  },
  props: {
    show: Boolean,
    page: String,
    redirectUrlParam: {
      type: Array,
      default: function () {
        return []
      }
    },
    facebookPages: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    }
  },
  created () {
    let that = this
    window.events.$on('removeGMBToken', function () {
      that.showAuthorisePage()
    })
  },
  mounted () {
    if (this.page === 'locationSetup') {
      this.locationSetupPage()
    } else if (this.page === 'locationUpdate') {
      this.locationUpdatePage()
    } else if (this.page === 'facebookPageSelect') {
      this.facebookSelectPage()
    } else {
      this.showAuthorisePage()
    }
  },
  computed: {
    showPrevButton () {
      return this.gmb.pageToken.currentApiToken
    },
    isSelectedLocationVerified () {
      return (this.selectedLocation !== '' && this.selectedLocation && this.selectedLocation.locationState && this.selectedLocation.locationState.isVerified === true && this.selectedLocation.metadata.newReviewUrl !== null)
    }
  },
  methods: {
    ...mapMutations({
      setGmbData: `gmb/${SET_GMB_DATA}`
    }),

    closeModal () {
      this.$emit('closeModal')
    },
    showAuthorisePage () {
      this.currentPage = 'askForAuth'
      this.title = 'Authorise Hellopeter on Google My Business'
      this.content = 'Hellopeter needs permission to access Google My Business on your behalf. Add your Google My Business location to manage your reviews'
      this.buttonText = 'GO TO GOOGLE MY BUSINESS'

      axios.get(`/social/gmb/get-auth-url/${this.businessSlug}?data=${this.redirectUrlParam.join('|!|')}`)
        .then(({ data }) => {
          this.authURL = data.url
        })
    },
    locationSetupPage () {
      this.isLoading = true
      this.currentPage = this.page
      this.title = 'Select the Google My Business location to add to your account'
      this.buttonText = 'ADD LOCATION'

      axios.get(`/social/gmb/get-accounts/${this.businessSlug}`)
        .then(({ data }) => {
          this.accounts = data
          this.isLoading = false
        }).catch((ex) => {
        if (ex.response.status === 500 && ex.response.data.message === 'invalid_grant') {
          axios.delete(`/social/gmb/remove-gmb-setup/${this.businessSlug}`)
            .then(({ data }) => {
              this.closeModal()
              window.events.$emit('removeGMBToken')
            }).catch(() => {
          })
        }
      })
    },
    facebookSelectPage () {
      this.isLoading = false
      this.currentPage = this.page
      this.title = ''
      this.buttonText = 'SELECT'
    },
    locationUpdatePage () {
      this.isLoading = true
      this.currentPage = this.page
      this.title = 'Select the Google My Business location to add to your account'
      this.buttonText = 'UPDATE LOCATION'

      axios.get(`/social/gmb/check-gmb-setup/${this.businessSlug}`)
        .then(({ data }) => {
          if (data.data.data !== null) {
            this.setGmbData(data.data)

            this.selectedAccount = {
              name: data.data.data.account,
              accountName: data.data.data.accountName
            }
            this.selectedLocationName = data.data.data.locationData.locationName

            if (this.selectedLocationName !== null) {
              axios.get(`/social/gmb/get-location/${this.businessSlug}/${data.data.data.location}`)
                .then(({ data }) => {
                  if (!data.exists) {
                    this.removeGMBAccount('noAccessToBusiness')
                    this.selectedLocation = undefined
                  } else {
                    this.selectedLocation = data.location
                  }
                }).catch((ex) => {
                if (ex.response.status === 500 && ex.response.data.message === 'invalid_grant') {
                  this.removeGMBAccount('')
                  this.selectedLocation = undefined
                }
              }).finally(() => {
                this.isLoading = false
                this.getLocationsByAccount()
              })
            } else {
              this.isLoading = false
              this.getLocationsByAccount()
            }
          }
        })
    },
    getLocationsByAccount: function (pageToken = '') {
      if (pageToken !== 'prev') {
        this.gmb.pageToken.logs[pageToken] = this.gmb.pageToken.currentApiToken
      } else {
        pageToken = this.gmb.pageToken.logs[this.gmb.pageToken.currentApiToken]
      }

      this.isLoading = true
      axios.get(`/social/gmb/get-locations-by-account/${this.businessSlug}/${this.selectedAccount.name}?pageToken=${pageToken}`)
        .then(({ data }) => {
          this.gmb.pageToken.currentApiToken = pageToken
          this.gmb.pageToken.next = data.nextPageToken

          this.locations = data.locs
          this.isLoading = false
        })
    },
    saveFacebookSelection () {
      this.isLoading = true
      // this.selectedPageToken = this.facebookPages[0]['pageToken']
      this.facebookPages.forEach((record) => {
        this.selectedPageToken = record['pageToken']
      })
      axios.post(`/social/fb/select-page/${this.businessSlug}`, {
        pageId: this.selectedLocation,
        token: this.selectedPageToken
      })
        .then(({ data }) => {
          this.closeModal()
          flash('We\'ve added your Facebook Page and your reviews will synchronize shortly', 'is-success')
          window.location.href = '/reviews'
        })
        .catch((error) => {
          if (error.response.data && error.response.data.message) {
            this.closeModal()
            flash('Something went wrong when trying to add your Facebook Page, please try again', 'is-danger')
            window.location.href = '/reviews'
          }
        })
    },
    saveAccountLocation () {
      if (this.selectedAccount === '' || this.selectedLocation === '' || this.isSelectedLocationVerified === false) {
        flash('Please select an Account and a verified Location', 'is-danger')
      } else {
        this.formData.account = this.selectedAccount.name
        this.formData.accountName = this.selectedAccount.accountName
        this.formData.location = this.selectedLocation.name
        this.formData.locationData = {
          locationName: this.selectedLocation.locationName,
          address: this.selectedLocation.address,
          locationState: this.selectedLocation.locationState,
          newReviewUrl: this.selectedLocation.metadata.newReviewUrl
        }
        axios.post(`/social/gmb/save-account-locations/${this.businessSlug}`, this.formData)
          .then(({ data }) => {
            this.closeModal()
            this.$emit('updateFinished')
            let widgetRedirectUrl = localStorage.getItem('widget_redirect_url')
            if (widgetRedirectUrl !== '' && widgetRedirectUrl !== null) {
              this.$router.push(widgetRedirectUrl)
            }
          })
      }
    },
    removeGMBAccount (key) {
      axios.delete(`/social/gmb/remove-gmb-setup/${this.businessSlug}`)
        .then(({ data }) => {
          this.closeModal()
          window.events.$emit('removeGMBToken', key)
        }).catch(() => {
      })
    }
  }
}
</script>
<style scoped>
/** Modal CSS Starts */
.modal-card {
  max-width: 579px;
  width: 100%;
  min-height: 214px;
}

.modal-card-head {
  border-top: 10px solid #1261a0;;
  padding-top: 0px;
  border-bottom: none !important;
  background-color: #fff;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.modal-card-head .cross-btn {
  font-size: 24px;
  position: absolute;
  top: 5px;
  right: 30px;
  cursor: pointer;
}

.modal-card-foot {
  border-top: none !important;
  background-color: #fff;
  border-radius: none !important;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  justify-content: space-between;
}

.modal-card-foot .pagination-link {
  order: 0
}

.modal-card-foot .button:last-child {
  margin-right: 10px;
}

.modal-card-foot .dark-blue-btn {
  background-color: #1261A0 !important;
  max-width: 230px;
  width: 100%;
  max-height: 35px;
}

.modal-card-foot .delete-btn {
  border: 1px solid #1261a0;
  color: #1261a0;
  max-width: 130px;
  width: 100%;
  max-height: 35px;
}

.modal-card-body {
  font-size: 12px;
  line-height: 17px;
  color: #707070;
}

.modal-card-body .title {
  color: #1261a0;
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
  text-align: center;
}

.modal-card-body p img {
  vertical-align: middle;
  margin-right: 5px;
}

.modal-card-body .form-group {
  margin: 25px 0 23px;
}

.modal-card-body .form-group .input {
  font-size: 12px;
  height: 35px;
}

.modal-card-body .form-group label {
  display: block;
  font-weight: bold;
  margin: 5px 0;
}

.modal-card-body .location-checkbox label {
  font-weight: normal;
}

.modal-card-body .location-checkbox input {
  margin-right: 10px;
}

.modal-background {
  background-color: #58595B;
  opacity: 0.4;
}

.location-not-verified {
  border: 1px solid #E4862C;
  color: #E4862C;
}

.location-not-verified .left {
  display: inline-block;
  border-right: 1px solid #E4862C;
  text-align: center;
  font-size: 16px;
  padding-top: 20px;
  font-weight: bold;
}

.location-not-verified .right a {
  text-decoration: underline;
  color: #30aae1;
}

.modal-card-body p img.fb_logo {
  display: block;
  width: 146px;
  height: 49px;
  margin: 0 auto !important;
}

/** Modal CSS Ends */
</style>



// WEBPACK FOOTER //
// src/components/GMBModal.vue